import { useCallback } from "react";

import { useAppDispatch } from "app/hooks";
import {
  setCustomMessage,
  setOpen
} from "components/action-snackbar/action-snackbar-slice";
import { convertHtmlToText } from "utils/common";

export default function useCopyHtmlContentToClipboard() {
  const dispatch = useAppDispatch();

  const handleCopyText = useCallback(
    async (value: string, displayMessage?: boolean) => {
      try {
        const plainText = convertHtmlToText(value);

        const htmlBlob = new Blob([value], { type: "text/html" });
        const textBlob = new Blob([plainText], { type: "text/plain" });
        const item = new ClipboardItem({
          "text/html": htmlBlob,
          "text/plain": textBlob
        });

        await navigator.clipboard.write([item]);
        if (displayMessage) {
          dispatch(setCustomMessage("Content copied to clipboard"));
          dispatch(setOpen(3000));
        }
      } catch (err) {
        console.error("Failed to copy text:", err);
      }
    },
    [dispatch]
  );

  return handleCopyText;
}
